import { render, staticRenderFns } from "./MarketLivePreviewClassic.vue?vue&type=template&id=2432a516&scoped=true"
import script from "./MarketLivePreviewClassic.vue?vue&type=script&lang=js"
export * from "./MarketLivePreviewClassic.vue?vue&type=script&lang=js"
import style0 from "./MarketLivePreviewClassic.vue?vue&type=style&index=0&id=2432a516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2432a516",
  null
  
)

export default component.exports